import {NgModule} from '@angular/core';

import {RadioTreeNodeComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {BaseTreeNodeModule} from '../base-tree-node/base-tree-node.component.module';

/**
 * Module for the TreeNodeModule
 * @class
 */
@NgModule({
  declarations: [RadioTreeNodeComponent],
  exports: [RadioTreeNodeComponent],
  imports: [IonicModule, BaseTreeNodeModule],
  providers: [],
})
export class RadioTreeNodeModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/radio-tree-node/radio-tree-node.component.module.ts